import { defineMessages } from "react-intl";

import { node as abdominalUltrasound } from "src/modules/htx/forms/screening-procedures/abdominalUltrasound";
import { node as abi } from "src/modules/htx/forms/screening-procedures/abi";
import { node as carotisDoppler } from "src/modules/htx/forms/screening-procedures/carotisDoppler";
import { node as chestCt } from "src/modules/htx/forms/screening-procedures/chestCt";
import { node as chestXray } from "src/modules/htx/forms/screening-procedures/chestXRay";
import { node as colonoscopy } from "src/modules/htx/forms/screening-procedures/colonoscopy";
import { node as dentalScreening } from "src/modules/htx/forms/screening-procedures/dentalScreening";
import { node as dermatology } from "src/modules/htx/forms/screening-procedures/dermatology";
import { node as dexa } from "src/modules/htx/forms/screening-procedures/dexa";
import { node as earNoseThroat } from "src/modules/htx/forms/screening-procedures/earNoseThroat";
import { node as gynecology } from "src/modules/htx/forms/screening-procedures/gynecology";
import { node as mammography } from "src/modules/htx/forms/screening-procedures/mammography";
import { node as ophthalmologicExamination } from "src/modules/htx/forms/screening-procedures/ophthalmologicExamination";
import { node as proteinuria } from "src/modules/htx/forms/screening-procedures/proteinuria";
import { node as psychiatry } from "src/modules/htx/forms/screening-procedures/psychiatry";
import { node as pulmonology } from "src/modules/htx/forms/screening-procedures/pulmonology";
import { node as stoolBlood } from "src/modules/htx/forms/screening-procedures/stoolBlood";
import { node as stoolculture } from "src/modules/htx/forms/screening-procedures/stoolculture";
import { node as urineculture } from "src/modules/htx/forms/screening-procedures/urineculture";
import { node as urinesediment } from "src/modules/htx/forms/screening-procedures/urinesediment";
import { node as urology } from "src/modules/htx/forms/screening-procedures/urology";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.screening_procedures",
		defaultMessage: "Szűrővizsgálatok"
	}
});

export const node: ParentNode = {
	id: "screeningProcedures",
	value: { type: "wizard", title: messages.title },
	children: [
		chestXray,
		chestCt,
		abdominalUltrasound,
		dermatology,
		pulmonology,
		dentalScreening,
		psychiatry,
		earNoseThroat,
		stoolBlood,
		urinesediment,
		urineculture,
		stoolculture,
		urology,
		gynecology,
		mammography,
		carotisDoppler,
		ophthalmologicExamination,
		abi,
		proteinuria,
		colonoscopy,
		dexa
	]
};
